import { Tab } from '../../../../../views/active-orders';

export default {
  title: 'Panel restauracji',
  tabs: {
    [Tab.OngoingOrders]: 'Przygotuj teraz',
    [Tab.FutureOrders]: 'Przyszłe',
    [Tab.CompleteOrders]: 'Zakończone',
  },
  buttons: {
    order_history: 'Historia zamówień',
  },
  feedback: {
    future_orders_alert: '⚠️ Jeszcze nie przygotowuj – powiadomimy Cię, kiedy zacząć.',
  },
};
